<div class="asc-dashboard-header" [class.asc-dashboard-header__home-tab]="tab === 'home'">
  <div>
    <div class="govuk-width-container">
      <div
        class="govuk-grid-row govuk__flex govuk__align-items-flex-end"
        [ngClass]="tab === 'workplace' ? 'govuk-!-padding-bottom-2' : 'govuk-!-padding-bottom-6'"
      >
        <div
          [ngClass]="tab === 'home' ? 'govuk-grid-column-one-half' : 'govuk-grid-column-two-thirds'"
          data-testid="column-one"
        >
          <ng-container *ngIf="tab === 'home'; else otherTab">
            <ng-container *ngIf="isParent && !isParentSubsidiaryView">
              <span class="govuk-caption-xl" data-testid="parentLabel">Parent</span>
            </ng-container>

            <ng-container *ngIf="workplace?.parentName && !isParentSubsidiaryView">
              <span class="govuk-caption-xl" data-testid="parentNameLabel">
                <ng-container *ngIf="isAdmin; else parentNameText">
                  <a
                    href="#"
                    class="govuk-link--no-visited-state"
                    data-testid="name-link"
                    (click)="navigateToParentWorkplace(workplace?.parentUid, '', '', $event)"
                  >
                    {{ workplace.parentName }}
                  </a>
                </ng-container>

                <ng-template #parentNameText>
                  {{ workplace.parentName }}
                </ng-template>
              </span>
            </ng-container>

            <span *ngIf="isParentSubsidiaryView" class="govuk-caption-xl" data-testid="selectedWorkplaceLabel"
              >Selected workplace</span
            >

            <h1
              data-testid="workplaceName"
              class="govuk-heading-l govuk-!-margin-bottom-0 asc-util__break-word-on-overflow"
            >
              {{ workplace?.name }}
            </h1>
          </ng-container>
          <ng-template #otherTab>
            <h1 data-testid="workplaceName" class="govuk-heading-l govuk-!-margin-bottom-0">
              <span class="govuk-caption-xl govuk-!-margin-bottom-0 asc-util__break-word-on-overflow">{{
                workplace?.name
              }}</span>
              {{ header }}
            </h1>
          </ng-template>
          <p class="govuk-!-font-size-16 govuk-!-margin-top-2 govuk-!-margin-bottom-0">
            <span class="govuk-!-margin-right-2">Workplace ID: {{ workplace?.nmdsId }}</span>
            <span *ngIf="updatedDate" data-testid="separator">|</span>

            <span *ngIf="updatedDate" class="govuk-!-margin-left-2" data-testid="lastUpdatedDate"
              >Last update, {{ updatedDate | date: 'd MMMM y' }}
            </span>
            <ng-container *ngIf="tab === 'home' && !isAdmin && lastLoggedInFromLogin && !isParentSubsidiaryView">
              <span data-testid="separator">|</span>

              <span class="govuk-!-margin-left-2"> Last sign in, {{ lastLoggedInFromLogin | date: 'd MMMM y' }} </span>
            </ng-container>
          </p>
        </div>
        <div
          [ngClass]="tab === 'home' ? 'govuk-grid-column-one-half' : 'govuk-grid-column-one-third'"
          data-testid="column-two"
        >
          <ng-container [ngSwitch]="tab">
            <ng-container *ngSwitchCase="'home'">
              <div class="govuk-util__float-right" *ngIf="tab === 'home'" data-testid="contact-info">
                <div
                  *ngIf="
                    (workplace && canDeleteEstablishment && subsidiaryCount < 1 && workplace.ustatus !== 'PENDING') ||
                    (canDeleteEstablishment && isParentSubsidiaryView)
                  "
                >
                  <a
                    data-testid="delete-workplace"
                    href="#"
                    class="govuk-button govuk-button--link govuk__flex govuk__align-items-center govuk-!-padding-left-0 govuk-!-margin-bottom-2"
                    (click)="navigateToDeleteWorkplace($event)"
                  >
                    <img src="/assets/images/bin.svg" alt="" />
                    <span class="govuk-!-margin-left-1">
                      Delete <span class="govuk-visually-hidden">{{ workplace?.name }}</span> workplace
                    </span>
                  </a>
                </div>

                <h2 class="govuk-heading-s govuk-!-margin-bottom-0">Contact Skills for Care</h2>
                <p class="govuk-!-font-size-16 govuk-!-margin-top-2 govuk-!-margin-bottom-0">
                  <span class="govuk-!-margin-right-2">0113 241 0969</span> |
                  <span class="govuk-!-margin-left-2">
                    <a href="mailto:ascwds-support@skillsforcare.org.uk">ascwds-support&#64;skillsforcare.org.uk</a>
                  </span>
                </p>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'workplace'">
              <div class="do-as-parent-link">
                <span
                  *ngIf="isParent"
                  class="govuk-width-container govuk-body govuk-!-font-size-19 govuk-util__align-right"
                  data-testid="do-as-parent"
                >
                  <a [routerLink]="['/workplace/about-parents']">What you can do as a parent</a>
                </span>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'staff-records'">
              <div *ngIf="canAddWorker" class="govuk-util__align-right">
                <a
                  role="button"
                  draggable="false"
                  class="govuk-button govuk-!-margin-bottom-5"
                  data-cy="add-staff-record-button"
                  [routerLink]="['/workplace', this.workplace.uid, 'staff-record', 'create-staff-record']"
                >
                  Add a staff record
                </a>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'training-and-qualifications'">
              <div *ngIf="hasWorkers && canEditWorker" class="govuk-util__align-right">
                <app-button-menu buttonText="Add and manage training">
                  <li>
                    <a
                      [routerLink]="['/workplace', workplace.uid, 'add-multiple-training', 'select-staff']"
                      role="button"
                      class="asc-button-menu__item"
                    >
                      Add multiple training records
                    </a>
                  </li>
                  <li>
                    <a
                      [routerLink]="['/workplace', workplace.uid, 'training-course', 'add-and-manage-training-courses']"
                      href="#"
                      role="button"
                      class="asc-button-menu__item"
                    >
                      Add training courses
                    </a>
                  </li>

                  <li *ngIf="hasTrainingCourse">
                    <a
                      [routerLink]="[
                        '/workplace',
                        workplace.uid,
                        'update-records-with-training-course-details',
                        'select-a-training-course',
                      ]"
                      role="button"
                      class="asc-button-menu__item govuk-!-margin-right-3"
                    >
                      Update records with training course details
                    </a>
                  </li>
                  <li>
                    <a
                      [routerLink]="['/workplace', workplace.uid, 'add-and-manage-mandatory-training']"
                      role="button"
                      class="asc-button-menu__item"
                    >
                      Manage mandatory training
                    </a>
                  </li>
                  <li>
                    <a
                      [routerLink]="['/workplace', workplace.uid, 'change-expires-soon-alerts']"
                      role="button"
                      class="asc-button-menu__item"
                    >
                      Manage expiry alerts
                    </a>
                  </li>
                </app-button-menu>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-container *ngIf="tab === 'workplace'">
  <app-display-workplace-name-address
    [workplace]="workplace"
    [canEditEstablishment]="canEditEstablishment"
    [return]="return"
    data-testid="workplace-address"
  ></app-display-workplace-name-address>
</ng-container>
